import React, { useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Navbar from "components/Navbars/AuthNavbar.js";
import Footer from "components/Footers/Footer.js";
import Carousel from "./carrousel";

export default function Protect() {
  const [expanded, setExpanded] = useState(null);

  const toggleAccordion = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  const [expandedPrevention, setExpandedPrevention] = useState(null);

const togglePrevention = (index) => {
  setExpandedPrevention(expandedPrevention === index ? null : index);
};

const preventionMeasures = [
  {
    title: "Vérifiez l'Authenticité",
    content:
      "Avant de partager des informations personnelles ou financières, assurez-vous que vous interagissez avec une source fiable. Recherchez notre logo officiel et utilisez uniquement les canaux de communication vérifiés de AidFoundation.",
  },
  {
    title: "Protégez vos Informations",
    content:
      "Ne partagez jamais vos informations personnelles ou financières, telles que vos numéros de compte ou de carte de crédit, avec des inconnus ou sur des sites non sécurisés.",
  },
  {
    title: "Méfiez-vous des Offres Trop Belles pour être Vraies",
    content:
      "Si une offre semble trop belle pour être vraie, elle l'est probablement. Soyez sceptique face aux promesses de gains rapides et faciles.",
  },
  {
    title: "Utilisez des Mots de Passe Sécurisés",
    content:
      "Créez des mots de passe forts et uniques pour vos comptes en ligne, et changez-les régulièrement. Évitez d'utiliser des informations faciles à deviner, comme des dates de naissance ou des noms de famille.",
  },
  {
    title: "Soyez Vigilant face aux Phishing",
    content:
      "Ne cliquez jamais sur des liens ou pièces jointes dans des emails ou messages suspects. Les arnaqueurs utilisent souvent le phishing pour obtenir des informations sensibles.",
  },
];


  const faqData = [
    {
      question: "Qu'est-ce qu'une aide financière non remboursable ?",
      answer:
        "Une aide financière non remboursable est un soutien financier qui n’a pas besoin d’être remboursé. Elle est souvent destinée à aider des individus ou des organisations à financer des projets spécifiques, des formations, ou des besoins urgents.",
    },
    {
      question: "Qui peut bénéficier de cette aide ?",
      answer:
        "Les bénéficiaires peuvent inclure des particuliers, des étudiants, des petites entreprises ou des associations à but non lucratif. Les critères d’éligibilité peuvent varier selon le programme d’aide.",
    },
    {
      question: "Quels documents sont nécessaires pour la demande ?",
      answer:
        "Les documents peuvent varier en fonction du type d’aide demandée, mais en général, vous devrez fournir :<ul class='list-none pl-6 mt-2 '><li>- Une pièce d’identité</li><li>- Un justificatif de domicile</li><li>- Un descriptif détaillé de votre projet</li><li>- Des devis ou estimations de coûts si nécessaire</li></ul>",
    },
    {
      question: "Quel est le délai de traitement des demandes ?",
      answer:
        "Le traitement des demandes peut prendre entre 24 à 72 heures, selon le volume des demandes reçues. Nous vous informerons dès que votre demande sera examinée.",
    },
    {
      question: "Comment éviter les arnaques lors de la recherche d'aide financière ?",
      answer:
        "Pour éviter les arnaques :<ul class='list-none pl-6 mt-2 '><li>- Ne partagez jamais d’informations personnelles ou financières sensibles par téléphone ou email.</li><li>- Méfiez-vous des offres qui semblent trop belles pour être vraies.</li><li>- Vérifiez toujours l’authenticité des sites et des organisations proposant des aides.</li><li>- Consultez des sources fiables et lisez les avis d’autres bénéficiaires.</li></ul>",
    },
    {
      question: "Que faire si je pense avoir été victime d'une arnaque ?",
      answer:
        "Si vous suspectez une arnaque, signalez-la immédiatement aux autorités locales ou à une organisation de protection des consommateurs. Vous pouvez également nous contacter pour signaler tout comportement suspect lié à notre programme d’aide.",
    },
    {
      question: "Comment suivre l’état de ma demande ?",
      answer:
        "Une fois votre demande soumise, vous recevrez un email de confirmation avec un numéro de suivi. Vous pourrez utiliser ce numéro pour suivre l’évolution de votre dossier via notre site.",
    },
    {
      question: "Qui puis-je contacter si j'ai d'autres questions ?",
      answer:
        "Pour toute question supplémentaire, vous pouvez nous contacter via notre formulaire de contact ou par téléphone. Nos équipes sont là pour vous aider !",
    },
  ];

  const [expandedSecurity, setExpandedSecurity] = useState(null);

const toggleSecurity = (index) => {
  setExpandedSecurity(expandedSecurity === index ? null : index);
};

const securityMeasures = [
  {
    title: "Protection des Données",
    description:
      "Nous utilisons des technologies de cryptage avancées pour protéger vos données personnelles et financières. Vos informations sont stockées en toute sécurité et ne sont jamais partagées sans votre consentement explicite.",
  },
  {
    title: "Authentification Multi-Facteurs",
    description:
      "Pour renforcer la sécurité de vos comptes, nous proposons l'authentification multi-facteurs (MFA). Cette mesure ajoute une couche supplémentaire de protection en demandant une vérification supplémentaire lors de la connexion.",
  },
  {
    title: "Surveillance 24/7",
    description:
      "Nos systèmes de sécurité surveillent en permanence les activités suspectes sur nos plateformes. En cas de détection de comportements inhabituels, des mesures immédiates sont prises pour protéger vos comptes.",
  },
  {
    title: "Éducation et Sensibilisation",
    description:
      "Nous fournissons régulièrement des informations et des ressources pour vous aider à identifier et éviter les arnaques. Consultez notre blog et nos bulletins d'information pour rester informé des dernières menaces et des meilleures pratiques en matière de sécurité.",
  },
];


  return (
    <>
      {/* STYLE CUSTOM BULLET */}
      <style>{`
  .custom-bullet li {
    position: relative;
    padding-left: 1.1em;  /* Moins décalé */
    margin-bottom: 0.35em;
  }
  .custom-bullet li::before {
    content: '.';
    position: absolute;
    left: 0;
    top: 0;
    font-size: 1.5em;    /* Plus petit */
    color: inherit;      /* Même couleur que le texte */
    font-weight: bold;
    line-height: 1;
    opacity: 0.9;
    display: inline-block;
    vertical-align: middle;
  }
`}</style>


      <main className="bg-blueGray-800 min-h-screen pb-8">
       
        <Carousel />

        <section className="bg-blueGray-800 py-10">
  <div className="container mx-auto px-4 text-center">
    <h2 className="text-3xl font-bold mb-8 text-white animate-bounce">
      Prévention des Arnaques et Sécurité Financière
    </h2>
    <p className="text-lg text-blueGray-100 leading-relaxed mb-6 max-w-2xl mx-auto">
      Chez <span className="font-semibold text-blue-400">AidFoundation</span>, la sécurité et la tranquillité d'esprit de nos clients sont nos priorités. Voici quelques conseils clés à garder en tête pour éviter les pièges financiers :
    </p>
    <div className="max-w-3xl mx-auto">
      {preventionMeasures.map((item, index) => (
        <div
          key={index}
          className={`mb-4 transition-all duration-300 ${
            expandedPrevention === index
              ? "shadow-xl bg-white"
              : "shadow-md bg-blueGray-900"
          } rounded-2xl overflow-hidden`}
        >
          <button
            className={`w-full flex justify-between items-center px-5 py-4 text-left focus:outline-none transition-colors duration-200 ${
              expandedPrevention === index
                ? "bg-blue-100 text-blue-800"
                : "bg-blueGray-900 text-white"
            }`}
            onClick={() => togglePrevention(index)}
          >
            <span className="text-lg font-semibold">{item.title}</span>
            <span
              className={`text-2xl transform transition-transform duration-300 ${
                expandedPrevention === index ? "rotate-45 text-blue-700" : "rotate-0"
              }`}
            >
              +
            </span>
          </button>
          <div
            className={`transition-all duration-300 px-6 overflow-hidden ${
              expandedPrevention === index ? "max-h-[400px] py-4" : "max-h-0 py-0"
            }`}
          >
            {expandedPrevention === index && (
              <p className="text-base text-blueGray-800 text-left">
                {item.content}
              </p>
            )}
          </div>
        </div>
      ))}
    </div>
  </div>
</section>


        {/* Section Mesures de Sécurité (version accordéon) */}
<section className="bg-blueGray-800 py-10">
  <div className="container mx-auto px-4 text-center">
    <h2 className="text-3xl font-bold mb-8 text-white animate-bounce">
      Nos Mesures de Sécurité
    </h2>
    <div className="max-w-3xl mx-auto">
      {securityMeasures.map((measure, index) => (
        <div
          key={index}
          className={`mb-4 transition-all duration-300 ${
            expandedSecurity === index
              ? "shadow-xl bg-white"
              : "shadow-md bg-blueGray-900"
          } rounded-2xl overflow-hidden`}
        >
          <button
            className={`w-full flex justify-between items-center px-5 py-4 text-left focus:outline-none transition-colors duration-200 ${
              expandedSecurity === index
                ? "bg-blue-100 text-blue-800"
                : "bg-blueGray-900 text-white"
            }`}
            onClick={() => toggleSecurity(index)}
          >
            <span className="text-lg font-semibold">{measure.title}</span>
            <span
              className={`text-2xl transform transition-transform duration-300 ${
                expandedSecurity === index ? "rotate-45 text-blue-700" : "rotate-0"
              }`}
            >
              +
            </span>
          </button>
          <div
            className={`transition-all duration-300 px-6 overflow-hidden ${
              expandedSecurity === index ? "max-h-[400px] py-4" : "max-h-0 py-0"
            }`}
          >
            {expandedSecurity === index && (
              <p className="text-base text-blueGray-800 text-left">
                {measure.description}
              </p>
            )}
          </div>
        </div>
      ))}
    </div>
  </div>
</section>


        {/* FAQ */}
        <section className="bg-blueGray-800 py-12">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-8 text-white animate-bounce">
              FAQ - Foire Aux Questions
            </h2>
            <div className="max-w-3xl mx-auto">
              {faqData.map((faq, index) => (
                <div
                  key={index}
                  className={`mb-4 transition-all duration-300 ${
                    expanded === index
                      ? "shadow-xl bg-white"
                      : "shadow-md bg-blueGray-900"
                  } rounded-2xl overflow-hidden`}
                >
                  <button
                    className={`w-full flex justify-between items-center px-5 py-4 text-left focus:outline-none transition-colors duration-200 ${
                      expanded === index
                        ? "bg-blue-100 text-blue-800"
                        : "bg-blueGray-900 text-white"
                    }`}
                    onClick={() => toggleAccordion(index)}
                  >
                    <span className="text-lg font-bold">{faq.question}</span>
                    <span
                      className={`text-2xl transform transition-transform duration-300 ${
                        expanded === index ? "rotate-45 text-blue-700" : "rotate-0"
                      }`}
                    >
                      +
                    </span>
                  </button>
                  <div
                    className={`transition-all duration-300 px-6 overflow-hidden ${
                      expanded === index ? "max-h-[400px] py-4" : "max-h-0 py-0"
                    }`}
                  >
                    {expanded === index && (
                      <div
                        className="text-base text-blueGray-800 text-left"
                        // Ici, on utilise dangerouslySetInnerHTML pour rendre le HTML (liste, etc.)
                        dangerouslySetInnerHTML={{ __html: faq.answer }}
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

         
      </main>
    </>
  );
}
